import { createFileRoute } from '@tanstack/react-router'
import { requireAnyPermission } from '../../../app/guards'
import { PayComponentsPage } from '../../../features/hr/pay-components-page'
import { payComponentSearchSchema } from '../../../features/hr/search'

/** Read with employees.read or payroll.read, changed with payComponents.manage. */
export const Route = createFileRoute('/_app/hr/pay-components')({
  staticData: { crumb: 'hrPayComponents' },
  validateSearch: payComponentSearchSchema,
  beforeLoad: ({ context }) =>
    requireAnyPermission(context.session, 'employees.read', 'payroll.read', 'payComponents.manage'),
  component: PayComponentsPage,
})
